"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const thor_1 = require("./thor");
const vendor_1 = require("./vendor");
const package_json_1 = require("@vechain/connex/package.json");
const driver_guard_1 = require("./driver-guard");
/**
 * Class implements Connex interface
 */
class Framework {
    /**
     * constructor
     * @param driver the driver instance
     */
    constructor(driver) {
        this.version = package_json_1.version;
        this.thor = thor_1.newThor(driver);
        this.vendor = vendor_1.newVendor(driver);
    }
    /**
     * create a wrapper for driver, to validate responses. it should be helpful to make sure driver is properly
     * implemented in development stage.
     * @param driver the driver to be wrapped
     * @param errorHandler optional error handler. If omitted, error message will be printed via console.warn.
     */
    static guardDriver(driver, errorHandler) {
        return driver_guard_1.newDriverGuard(driver, errorHandler);
    }
}
exports.Framework = Framework;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxpQ0FBZ0M7QUFDaEMscUNBQW9DO0FBQ3BDLCtEQUF1RTtBQUN2RSxpREFBK0M7QUFFL0M7O0dBRUc7QUFDSCxNQUFhLFNBQVM7SUFrQmxCOzs7T0FHRztJQUNILFlBQVksTUFBdUI7UUFSbkIsWUFBTyxHQUFHLHNCQUFhLENBQUE7UUFTbkMsSUFBSSxDQUFDLElBQUksR0FBRyxjQUFPLENBQUMsTUFBTSxDQUFDLENBQUE7UUFDM0IsSUFBSSxDQUFDLE1BQU0sR0FBRyxrQkFBUyxDQUFDLE1BQU0sQ0FBQyxDQUFBO0lBQ25DLENBQUM7SUF4QkQ7Ozs7O09BS0c7SUFDSSxNQUFNLENBQUMsV0FBVyxDQUNyQixNQUF1QixFQUN2QixZQUFtQztRQUVuQyxPQUFPLDZCQUFjLENBQUMsTUFBTSxFQUFFLFlBQVksQ0FBQyxDQUFBO0lBQy9DLENBQUM7Q0FjSjtBQTFCRCw4QkEwQkMifQ==